import {vec3} from "_src/libs/gl-matrix";

export default class Batcher {

  constructor() {

    this.objects = [];

    this.opaque = [];
    this.blend = [];

    this.needsSort = false;
    this.sortBlend = false;

  }

  addObject(object) {

    if (object.isDrawable) {

      if (this.objects.indexOf(object) == -1) {
        this.objects.push(object);
      }

    }

    for (let i = 0; i < object._children.length; ++i) {
      this.addObject(object._children[i]);
    }

  }

  removeObject(object) {

    if (object.isDrawable) {

      const ind = this.objects.indexOf(object);
      if (ind != -1) {
        this.objects.splice(ind, 1);
      }

    }

    for (let i = 0; i < object._children.length; ++i) {
      this.removeObject(object._children[i]);
    }

  }

  generatePasses() {

    for (let i = 0; i < this.objects.length; ++i) {

      const object = this.objects[i];
      const shader = object.shader;

      if (!object.isHidden) {
        shader.id || shader.generateUniqueID();

        if (shader.transparent) {
          this.blend.push(object);
        } else {
          this.opaque.push(object);
        }
      }

    }

    if (this.blend.length > 2) {
      this.blend.sort(compareShaderIDs);
    }
    if (this.opaque.length > 2) {
      this.opaque.sort(compareShaderIDs);
    }
  }

  sortBlendQueue(point) {
    this.blend.sort((objectA, objectB) => {
      return compareOriginsNearestFirst(point, objectA, objectB);
    });
  }

  sortObjects(point) {

    for (let object of this.objects) {

      if (object.isDrawable && object.chunks.length > 1) {
        object.chunks.sort((chunkA, chunkB) => {

          if (!chunkA.hasDrawElements() || !chunkB.hasDrawElements()) {
            return -1;
          }

          return compareBoundingsNearestFirst(point, object.getChunkBBox(chunkA), object.getChunkBBox(chunkB));

        });
      }

    }

    // NOTE: we sort objects in lists by shader id
    // if (this.objects.length > 1) {
    //   this.objects.sort((objectA, objectB) => {
    //     return compareObjects(point, objectA, objectB);
    //   });
    // }

    this.needsSort = false;

  }

  getOpaqueQueue() {
    return this.opaque;
  }

  getBlendQueue() {
    return this.blend;
  }

  cleanup() {

    this.objects.length = 0;
    this.opaque.length = 0;
    this.blend.length = 0;

  }
  
}

function compareShaderIDs(lshader, rshader) {
  return lshader.id - rshader.id;
}

// function compareObjects(point, objectA, objectB) {

//   //NOTE: special case for frames
//   if (objectA.isDrawable && objectB.isDrawable) {

//     const chunksA = objectA.chunks;
//     const chunksB = objectB.chunks;

//     if (chunksA.length == 1 && chunksB.length == 1) {
//       const bboxA = objectA.getChunkBBox(chunksA[0]);
//       const bboxB = objectB.getChunkBBox(chunksB[0]);
//       return compareBoundingsNearestFirst(point, bboxA, bboxB);
//     }

//   }

//   return compareOriginsNearestFirst(point, objectA, objectB);

// }

const compareBoundingsNearestFirst = (function() {

  const _vec3Tmp = vec3.create();
  const _vec3Tmp2 = vec3.create();

  return function(point, bboxA, bboxB) {

    const pointA = vec3.set(_vec3Tmp, 0.5 * (bboxA[3] + bboxA[0]),
                                      0.5 * (bboxA[4] + bboxA[1]),
                                      0.5 * (bboxA[5] + bboxA[2]));

    const pointB = vec3.set(_vec3Tmp2, 0.5 * (bboxB[3] + bboxB[0]),
                                       0.5 * (bboxB[4] + bboxB[1]),
                                       0.5 * (bboxB[5] + bboxB[2]));

    return vec3.squaredDistance(point, pointA) - vec3.squaredDistance(point, pointB);

  }

})();

const compareOriginsNearestFirst = (function() {

  const _vec3Tmp = vec3.create();
  const _vec3Tmp2 = vec3.create();

  return function(point, objectA, objectB) {

    const pointA = vec3.set(_vec3Tmp, 0.0, 0.0, 0.0);
    vec3.transformMat4(pointA, pointA, objectA.modelMatrix);

    const pointB = vec3.set(_vec3Tmp2, 0.0, 0.0, 0.0);
    vec3.transformMat4(pointB, pointB, objectB.modelMatrix);

    return vec3.squaredDistance(point, pointA) - vec3.squaredDistance(point, pointB);

  }

})();
